import { Grid } from '@chakra-ui/react';
import FullpageSpinner from 'components/FullpageSpinner';
import Footer from 'components_2/footer';
import React from 'react';
import { getEditorialFeaturedTest } from 'services/featuredList';
import useSWR from 'swr';
import EditorialDetailContainer from './components/atoms/EditorialDetailContainer';
import EditorialCard from './components/cards/EditorialCard';
import { EditorialPlayerProvider } from './hooks/useEditorialPlayer';

const EditorialFeaturedTest = () => {
  const { data: editorialList, isValidating: isLoading } = useSWR(
    '/editorial/data/en/test',
    async () => {
      const editorials = await getEditorialFeaturedTest();

      return editorials;
    },
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );

  if (isLoading) return <FullpageSpinner />;

  return (
    <EditorialPlayerProvider>
      <EditorialDetailContainer
        maxW="1290px"
        py={{ base: 10, lg: 20 }}
        px={{ base: 30, md: 10, xl: 0 }}
      >
        <Grid
          templateColumns={{
            base: 'repeat(1, 1fr)',
            md: 'repeat(2, 1fr)',
            lg: 'repeat(3, 1fr)',
            xl: 'repeat(4, 1fr)'
          }}
          gap={4}
        >
          {editorialList?.items?.map(item => (
            <EditorialCard
              editorial={item.item_summary.editorial_summary}
              editorialMetadata={item.metadata}
              key={item.item_summary.editorial_summary?.id}
            />
          ))}
        </Grid>
      </EditorialDetailContainer>
      <Footer />
    </EditorialPlayerProvider>
  );
};

export default EditorialFeaturedTest;
